// Náročnosť návyku a bodová ekonomika v29.
//
// MIRROR: `db.py` (DIFF_POINTS / DIFF_STARS / DIFF_SK / STREAK_COEF / streak_coef /
// difficulty_points / norm_difficulty) zrkadlí presne túto logiku — rovnaké spec
// príklady žijú v `points.test.ts` aj ako inline asserty pri importe `db.py`,
// aby sa Python a JS ticho nerozišli.
//
// Body za splnenie = round(DIFF_POINTS[náročnosť] × KOEF(séria vrátane tohto splnenia)):
//   séria 1.–2. ×1,0 · 3.–6. ×1,2 · 7.–13. ×1,4 · 14.–29. ×1,6 · 30.+ ×2,0

export type Difficulty = "easy" | "normal" | "hard";

/** Základné body podľa náročnosti (bez koeficientu série). */
export const DIFF_POINTS: Record<Difficulty, number> = { easy: 5, normal: 10, hard: 20 };
/** Počet hviezdičiek v štítku náročnosti. */
export const DIFF_STARS: Record<Difficulty, 1 | 2 | 3> = { easy: 1, normal: 2, hard: 3 };
/** Slovenský názov náročnosti (UI copy). */
export const DIFF_SK: Record<Difficulty, string> = {
  easy: "jednoduchý",
  normal: "normálny",
  hard: "náročný",
};
/** Poradie úrovní vo výbere náročnosti. */
export const DIFFICULTIES: readonly Difficulty[] = ["easy", "normal", "hard"];
/** Náročnosť, ktorou sa číta chýbajúca/neznáma hodnota. */
export const DEFAULT_DIFFICULTY: Difficulty = "normal";

/** (dolná hranica série, koeficient) — zoradené vzostupne. */
export const STREAK_COEF: readonly (readonly [number, number])[] = [
  [1, 1.0],
  [3, 1.2],
  [7, 1.4],
  [14, 1.6],
  [30, 2.0],
];

/** Ľubovoľný vstup → platná náročnosť. null/neznáme → "normal". */
export const normDifficulty = (v: unknown): Difficulty => {
  const s = typeof v === "string" ? v.trim().toLowerCase() : "";
  return (s in DIFF_POINTS ? s : DEFAULT_DIFFICULTY) as Difficulty;
};

/** Dĺžka série (vrátane práve zapisovaného splnenia) → násobiteľ. n ≤ 0 → 1,0. */
export const streakCoef = (n: number): number => {
  const c = Number.isFinite(n) ? Math.trunc(n) : 0;
  let coef = 1.0;
  for (const [lo, k] of STREAK_COEF) {
    if (c >= lo) coef = k;
    else break;
  }
  return coef;
};

/**
 * Body za splnenie návyku danej náročnosti, keď bude jeho séria po tomto splnení
 * dlhá `streak`. Zrkadlo `db.award_for` (bez DB — séria príde z API).
 */
export const pointsFor = (d: Difficulty | null | undefined, streak: number): number =>
  Math.round(DIFF_POINTS[normDifficulty(d)] * streakCoef(Math.max(1, streak || 0)));
